import { ListItem, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { Platform } from 'react-native'
import { BooleanRow } from 'shared/components/boolean_row'
import {
  BooleanFilter,
  Filter,
  MultiSelectFilter,
  SingleSelectFilter,
} from '../types'

interface Props {
  filter: Filter
  onPress(filter: Filter, booleanValue?: boolean | undefined): void
}
interface RowProps<T = Filter> {
  filter: T
  onPress(filter: T, booleanValue?: boolean | undefined): void
}

export function FilterRow({ filter, onPress }: Props) {
  switch (filter.type) {
    case 'boolean':
      return <BooleanFilterRow filter={filter} onPress={onPress} />
    case 'multiSelect':
      return <MultiSelectRow filter={filter} onPress={onPress} />
    case 'singleSelect':
      return <SingleSelectRow filter={filter} onPress={onPress} />
  }
}

function BooleanFilterRow({ filter, onPress }: RowProps<BooleanFilter>) {
  const styles = useStyles()
  function onValueChange() {
    onPress(filter, !filter.on)
  }
  return (
    <BooleanRow
      title={t(filter.name)}
      value={filter.on}
      onToggle={onValueChange}
    />
  )
}

function MultiSelectRow({ filter, onPress }: RowProps<MultiSelectFilter>) {
  const styles = useStyles()
  return (
    <ListItem
      onPress={() => onPress(filter)}
      containerStyle={styles.multiSelectRow}
    >
      <ListItem.Content>
        <ListItem.Title>{t(filter.name)}</ListItem.Title>
      </ListItem.Content>
      <ListItem.Content right>
        <ListItem.Subtitle style={styles.selectedText}>
          {numberOfSelectedValues(filter)}
        </ListItem.Subtitle>
      </ListItem.Content>
      <ListItem.Chevron />
    </ListItem>
  )
}

function SingleSelectRow({ filter, onPress }: RowProps<SingleSelectFilter>) {
  const styles = useStyles()
  return (
    <ListItem
      onPress={() => onPress(filter)}
      containerStyle={styles.multiSelectRow}
    >
      <ListItem.Content>
        <ListItem.Title>{t(filter.name)}</ListItem.Title>
      </ListItem.Content>
      <ListItem.Content right>
        <ListItem.Subtitle style={styles.selectedText}>
          {filter.selectedId && filter.values
            ? filter.values.find(value => value.id === filter.selectedId)?.name
            : t('all')}
        </ListItem.Subtitle>
      </ListItem.Content>
      <ListItem.Chevron />
    </ListItem>
  )
}

function numberOfSelectedValues(filter: MultiSelectFilter): string {
  const count = filter.selectedIds.length
  return count ? `${count} ${t('selected')}` : t('all')
}

const useStyles = makeStyles(theme => ({
  selectedText: {
    color: theme.colors?.grey1,
  },
  row: {
    paddingVertical: 10,
  },
  multiSelectRow: {
    ...Platform.select({
      ios: {},
      android: { paddingVertical: 22 },
      default: {},
    }),
  },
}))
